(function($){
  $(window).on('load', function() {
    $('.header-animation').addClass('is-loaded');
  });
})(jQuery);
